export default "__VITE_ASSET__b25b40fa__"